import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Loader2, ChevronRight } from "lucide-react";
import { api, priceLabel, STATUS_LABEL, STATUS_COLOR } from "@/lib/api";
import BackButton from "@/components/BackButton";
import { useServiceMap } from "@/lib/data";
import { ServiceIcon } from "@/lib/icons";

export function RequestRow({ r, name }) {
  const services = useServiceMap();
  const svc = services[r.service_slug];
  return (
    <Link to={`/pedido/${r.id}`} className="po-card flex items-center gap-4 transition-shadow hover:shadow-md" data-testid={`request-row-${r.id}`}>
      <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-orange-100 text-orange-600"><ServiceIcon icon={svc?.icon} className="h-7 w-7" /></span>
      <div className="min-w-0 flex-1">
        <p className="text-lg font-bold text-slate-900">{name || svc?.name || r.service_name}</p>
        <p className="truncate text-base text-slate-600">{r.neighborhood}, {r.city} · {new Date(r.created_at).toLocaleDateString("pt-BR")}</p>
        <p className="text-base font-semibold text-orange-700" data-testid={`request-row-price-${r.id}`}>{priceLabel(r)}</p>
      </div>
      <span className={`rounded-full px-3 py-1 text-sm font-bold ${STATUS_COLOR[r.status]}`}>{STATUS_LABEL[r.status]}</span>
      <ChevronRight className="h-6 w-6 text-slate-400" />
    </Link>
  );
}

export default function MyRequests() {
  const { data = [], isLoading } = useQuery({ queryKey: ["my-requests"], queryFn: () => api.get("/requests/mine").then((r) => r.data), refetchInterval: 10000 });
  return (
    <div className="mx-auto max-w-2xl px-4 py-6 sm:px-6">
      <BackButton />
      <h1 className="font-display text-3xl font-extrabold text-slate-900 sm:text-4xl">Meus pedidos</h1>
      {isLoading && <Loader2 className="mx-auto mt-10 h-10 w-10 animate-spin text-orange-500" />}
      {!isLoading && data.length === 0 && (
        <div className="po-card mt-6 text-lg" data-testid="my-requests-empty">Você ainda não fez nenhum pedido. <Link to="/" className="font-semibold text-orange-600 underline">Escolher serviço</Link></div>
      )}
      <div className="mt-6 space-y-3" data-testid="my-requests-list">{data.map((r) => <RequestRow key={r.id} r={r} />)}</div>
    </div>
  );
}
